import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  colors: [],
  status: "",
  count: 0,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    colorSelected: (state, action) => {
      if (state.colors.includes(action.payload)) {
        state.colors = state.colors.filter((color) => color !== action.payload);
      } else {
        state.colors.push(action.payload);
      }
    },
    filterStatus: (state, action) => {
      state.status = action.payload;
    },
    addCount: (state, action) => {
      state.count = action.payload;
    },
  },
});
export const { colorSelected, filterStatus, addCount } = filterSlice.actions;
export default filterSlice.reducer;
